import TimeUtils from "../../../../../../logic/common/timeUtils";
import type { RecordingToolPermissionDeniedTypeLegacy } from "../../../../types";

export const RECORDINGS_FOLDER_NAME = "Recordings";

export const getDateForFileName = (): string => {
    return TimeUtils.getEditorReadableTimeDate(Date.now());
};

export const getPermissionDeniedModalTitle: Record<RecordingToolPermissionDeniedTypeLegacy, string> = {
    "camera": "Camera is blocked",
    "microphone": "Microphone is blocked",
    "cameraAndMicrophone": "Camera and microphone are blocked"
};

export const getPermissionDeniedModalDescription: Record<RecordingToolPermissionDeniedTypeLegacy, string> = {
    "camera": "Change the camera permissions in the site settings.",
    "microphone": "Change the microphone permissions in the site settings.",
    "cameraAndMicrophone": "Change the camera and microphone permissions in the site settings."
};
